var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',{class:{checked:_vm.cheked},attrs:{"data-id":_vm.dataId,"data-num":_vm.stockNumber},on:{"click":function($event){return _vm.handleClick($event)}}},[_vm._v(_vm._s(_vm.stockNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }